import * as Yup from 'yup';

const residentialDetailsValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),

  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .trim("Mobile number cannot include leading and trailing spaces")
    .matches(/^\+254\d{9}$/, "Correct format is +254#########")
    .min(13, "Mobile number must be exactly 13 characters")
    .max(13, "Mobile number must be exactly 13 characters")
});

export default residentialDetailsValidationSchema;
